<template>
    <div id="contendor-principal-altadeResolucionyExtracto">
            <div id="encabezados-tp">
                <h1>{{ this.usuarioEditable ? 'EDICION ' : 'ALTA '  }} DE RESOLUCION Y EXTRACTO</h1>
                <h3>Ingrese la información requerida para guardar la cédula</h3>
                <h4>{{this.tablaResolucion.params.consecutivoTocaOral != undefined && this.tablaResolucion.params.consecutivoTocaOral != '' ? 'Toca Oral: ' + this.tablaResolucion.params.consecutivoTocaOral : ''}}</h4>
                <h4>{{this.tocaOral != undefined && this.tocaOral != '' ? 'Toca Oral: ' + this.tocaOral : ''}}</h4>
                <div class="hr-titulo"></div>
            </div>
            <div id="contendor-formulario-creacionDeCedula" class="padding-div-low">
                <div id="contenedor-creacionCedula" class="col-12">
                    <ul class="nav nav-tabs" id="nav-tab-formulario-cedula" role="tablist">
                         <li class="nav-item">
                            <a class="nav-link active" id="alta-resolucion-tab" data-toggle="tab" href="#alta-resolucion" role="tab" aria-controls="alta-resolucion" aria-selected="true"><i class="fas fa-archive"></i>&nbsp;Resolucion</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link " id="alta-extracto-tab" data-toggle="tab" href="#alta-extracto" role="tab" aria-controls="alta-extracto" aria-selected="true"><i class="fas fa-edit"></i>&nbsp;Extracto</a>
                        </li>   
                    </ul>
                    <div class="nav_tab_formularios" id="pasos-creacion-cedula">
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="alta-resolucion" role="tabpanel" aria-labelledby="alta-resolucion-tab">
                                <h3>{{ this.usuarioEditable ? 'Edicion ' : 'Alta '  }} de Resolucion</h3>
                                    <div class="contenedor-color-negro col-12">                                    
                                        <!-- PARAMETROS PARA LA RESOLUCION DE AMPARO -->
                                        <div class="form-group row g-12">
                                            <div class="col-4">
                                                <h6>Resolucion de Amparo</h6>
                                                <CCatalogoTipoResolucion class="p-0 m-0" 
                                                v-on:valorParaElPadre="evtCambioTipoResolucion" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="'CTipoResolucion'" 
                                                :elementosCatalogo="tablaResolucion.filtros.tipoDeResolucion.lista"
                                                :textoOpcionesSingular="'resolucion'"
                                                :valorDefinido="this.valoresdefinidos.vTipodeResolucion"
                                                :key="this.keys.keyTipodeResolicion">
                                                </CCatalogoTipoResolucion>
                                            </div>
                                            <div v-show="vshowdata" class="col-4">
                                                <h6>Magistrados</h6>
                                                <CCatalogoGenerico class="p-0 m-0" 
                                                v-on:valorParaElPadre="evtCambioMagistrado" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="'CMagistrados'" 
                                                :elementosCatalogo="tablaResolucion.filtros.magistrados.listmagistrados"
                                                :textoOpcionesSingular="'magistrado'"
                                                :valorDefinido="this.valoresdefinidos.vMagistrado"
                                                :key="this.keys.keyMagistrado">
                                                </CCatalogoGenerico>
                                            </div>
                                            <div v-show="vshowdata" class="col-4">
                                                <h6>Tipo De Procedencia</h6>
                                                <CCatalogoGenerico class="p-0 m-0" 
                                                v-on:valorParaElPadre="evtCambioTipoDeProcedencia" 
                                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                                :idDelInput="'CTipoDeProcedencia'" 
                                                :elementosCatalogo="tablaResolucion.filtros.tipoDeProcedencia.listtipodeprocedencia"
                                                :textoOpcionesSingular="'procedencia'"
                                                :valorDefinido="this.valoresdefinidos.vTipodeProcedencia"
                                                :key="this.keys.keyTipodeProcedencia">
                                                </CCatalogoGenerico>
                                            </div>
                                            <div v-show="vshowdata" class="col-8">
                                                <h6 style="width: 100%;">Observaciones</h6>
                                                <textarea type="text" rows="3" id="descripcion_contenido" class="form-control" placeholder="Ingrese informacion adicional acerca del amparo" v-model="tablaResolucion.params.observacionesResolucion" />
                                            </div>
                                            <div v-show="vshowdata" class="col-12">
                                                <h6 style="width: 100%;">Cargar Resolucion</h6>
                                                <div class="mb-3">
                                                    <label for="cargarResolucion" class="form-label">Seleccione el archivo (.doc .docx .pdf) a subir</label>
                                                    <input class="form-control" type="file" id="cargarResolucion" v-on:change="evtAgregarArchivoResolucion($event)">
                                                </div>
                                            </div>
                                            <div v-show="vshowdata" class="col-12">
                                                <div id="visor_contenedor">                        
                                                    <div id="visor_archivo">                                                 
                                                      <PDFDocument  :height="'750px'" :url="this.valoresdefinidos.vurlDocumentoR" :ArchivoAConvertir="tablaResolucion.params.archivoDeResolucion" :key="updateDocumentoResolucion.key"/>
                                                    </div>
                                                </div>   
                                            </div>
                                        </div>                            
                                    </div>
                            </div>
                            <div class="tab-pane fade " id="alta-extracto" role="tabpanel" aria-labelledby="alta-extracto-tab">
                                <h3>{{ this.usuarioEditable ? 'Edicion ' : 'Alta '  }} de Extracto</h3>
                                <div class="contenedor-color-negro col-12">                                    
                                    <!-- PARAMETROS PARA LA RESOLUCION DE AMPARO -->
                                    <div class="form-group row g-12">
                                        <div v-show="vshowdata" class="col-12">
                                            <h6 style="width: 100%;">Cargar Extracto</h6>
                                            <div class="mb-3">
                                                <label for="cargarExtracto" class="form-label">Seleccione el archivo (.doc .docx .pdf) a subir</label>
                                                <input class="form-control" type="file" id="cargarExtracto" v-on:change="evtAgregarArchivoExtracto($event)">
                                            </div>
                                        </div>
                                        <div v-show="vshowdata" class="col-12">
                                            <div id="visor_contenedor">                        
                                                <div id="visor_archivo">                                                 
                                                  <PDFDocument  :height="'750px'" :url="this.valoresdefinidos.vurlDocumentoE" :ArchivoAConvertir="tablaResolucion.params.archivoDeExtracto" :key="updateDocumentoExtracto.key"/>
                                                </div>
                                            </div>   
                                        </div>
                                    </div>                            
                                </div>
                             
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-end">
                <div class="col-2">
                    <button type="button" @click="evtAltaResolucion()" class="form-control btn btn-primary "><i class="fa fa-upload"></i>&nbsp;&nbsp;Guardar</button>
                </div>
            </div>
    </div>
</template>


<script>
    import Layout from '@/components/SICPE/Comun/Plantilla.vue';
    import enumeraciones from '@/../static/js/enumeraciones'
    import catalogos from '@/../static/js/catalogos'
    import comun from '@/../static/js/comun'
    import api from '@/../static/js/api'
    import axios from 'axios'
    import PDFDocument from '@/../src/components/Comunes/PDFDocument'
    import CCatalogoGenerico from '@/../src/components/SICPE/Comun/CCatalogoGenerico'
    import CCatalogoTipoResolucion from '@/../src/components/SICPE/Comun/CCatalogoTipoResolucion'
    import router from '@/router/index'
  
    export default {
      data() {
        return {
          vshowdata: true,  
          usuarioEditable: false,
          tocaOral:'',
          enumeraciones,
          updtCriterio: -1,
          keys: {
              keyMagistrado: -1,
              keyTipodeProcedencia: -1,
              keyTipodeResolicion:-1,
          },
          valoresdefinidos: {
              vMagistrado: -1,
              vTipodeProcedencia: -1,
              vTipodeResolucion:-1,
              vurlDocumentoR: '',
              vurlDocumentoE: '',
          },
          tablaResolucion: {
                ID: 'Tabla-criterios-penales',
                filtros: {
                    tipoDeResolucion: {
                        tipoDeResolucionId: -1,
                        lista: [],
                    },
                    tipoDeProcedencia: {
                        listtipodeprocedencia: [],
                    },
                    magistrados: {
                        listmagistrados: [],
                    }
                },
                amparos: [],
                params:{
                    tiporesolucionid: -1,
                    observacionesResolucion:'',
                    observacionesExtracto:'',
                    archivoDeResolucion: null,
                    archivoDeExtracto: null,
                    numExpediente: '',
                    consecutivoTocaOral: '',
                    consecutivoAmparo: '',
                    amparoDocumentopadreId: -1,
                    tipoDeProcedenciaId: -1,
                    magistrado: -1,
                    UsuarioId: -1
                },
            },
            updateDocumentoResolucion: {
                key: 0
            },
            updateDocumentoExtracto: {
                key: 0
            }
        }
      },
      components: {
        CCatalogoGenerico,
        PDFDocument,
        CCatalogoTipoResolucion
      },
      computed:{
      },
      methods: {
        evtAltaResolucion: function(){
            if(this.usuarioEditable)
            {
                let peticionAPIedit = this.getParametrosEditResolucion();
                this.updateAltaResolucion(peticionAPIedit);//api editar
            }
            else
            {
                let peticionAPIalta = this.getParametrosAltaResolucion();
                this.addAltaResolucion(peticionAPIalta);
            } 
            
        },
        addAltaResolucion: function(peticionAPI){
            const SERVIDOR = api.conexion;
            const METODO_API_AGREGAR = "SICPE/Registro/GuardarNuevoCriterioPenal"//(this.formularioEstaEditando) ? api.SINOJ.sistema.administracion.plantillas.ModificarPlantilla :api.SINOJ.sistema.administracion.plantillas.GuardarNuevaPlantilla;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            let peticionArchivos = true;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio);
                            comun.SeEstaCargandoInformacion(false);
                            //aqui podemos limpiar las variables
                            this.cleanParametros();
                            let valor = true;
                            this.$emit('evtFinalizado', valor);
                        }
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            );
        },
        updateAltaResolucion: function(peticionAPI){
            const SERVIDOR = api.conexion;
            const METODO_API_AGREGAR = "SICPE/Registro/EditarCriterioPenal"//(this.formularioEstaEditando) ? api.SINOJ.sistema.administracion.plantillas.ModificarPlantilla :api.SINOJ.sistema.administracion.plantillas.GuardarNuevaPlantilla;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            let peticionArchivos = true;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio);
                            comun.SeEstaCargandoInformacion(false);
                            this.cleanParametros();
                            let valor = true;
                            router.push({ 
                                            name: "Consulta"
                                        });
                        }
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            );
        },
        getParametrosAltaResolucion: function(){
            let peticion = new FormData();
            let agregarResolucionOBJ = {};
            if(this.tablaResolucion.params.tiporesolucionid == 9 || this.tablaResolucion.params.tiporesolucionid == 10)
            {
                agregarResolucionOBJ.ConsecutivoTocaOral = this.tablaResolucion.params.consecutivoTocaOral;
                agregarResolucionOBJ.ConsecutivoAmparo = this.tablaResolucion.params.consecutivoAmparo;
                agregarResolucionOBJ.AmparoID_DocumentoPadreIDMajat = this.tablaResolucion.params.amparoDocumentopadreId;
                agregarResolucionOBJ.TipoResolucionID_TipoResolucionMajat = this.tablaResolucion.params.tiporesolucionid;
                agregarResolucionOBJ.ObservacionesResolucion = this.tablaResolucion.params.observacionesResolucion;
                agregarResolucionOBJ.ObservacionesExtracto = this.tablaResolucion.params.observacionesExtracto;
                agregarResolucionOBJ.TipoDeProcedencia = this.tablaResolucion.params.tipoDeProcedenciaId;
                agregarResolucionOBJ.Magistrado = this.tablaResolucion.params.magistrado;
                agregarResolucionOBJ.UsuarioId_001DBCUENTAS = this.tablaResolucion.params.UsuarioId;
                console.log("PARAMETROS DE CONSEDIDONEGADO",agregarResolucionOBJ);
            }
            else
            {
                agregarResolucionOBJ.ConsecutivoTocaOral = this.tablaResolucion.params.consecutivoTocaOral;
                agregarResolucionOBJ.ConsecutivoAmparo = this.tablaResolucion.params.consecutivoAmparo;
                agregarResolucionOBJ.AmparoID_DocumentoPadreIDMajat = this.tablaResolucion.params.amparoDocumentopadreId;
                agregarResolucionOBJ.TipoResolucionID_TipoResolucionMajat = this.tablaResolucion.params.tiporesolucionid;
                agregarResolucionOBJ.ObservacionesResolucion = null;
                agregarResolucionOBJ.ObservacionesExtracto = null;
                agregarResolucionOBJ.TipoDeProcedencia = 0;
                agregarResolucionOBJ.Magistrado = 0;
                agregarResolucionOBJ.UsuarioId_001DBCUENTAS = this.tablaResolucion.params.UsuarioId;
                console.log("PARAMETROS DE OTRO",agregarResolucionOBJ);
            }
                        
            peticion.append('RESOLUCION',this.tablaResolucion.params.archivoDeResolucion);
            peticion.append('EXTRACTO',this.tablaResolucion.params.archivoDeExtracto);
            peticion.append('TipoPlantilla',JSON.stringify(agregarResolucionOBJ));
            peticion.append('EsPrueba',false);

            console.log("Parametros: ",peticion);
            
            return peticion;
        },
        getParametrosEditResolucion: function(){
            let peticion = new FormData();
            let agregarResolucionOBJ = {};

            agregarResolucionOBJ.AmparoID_DocumentoPadreIDMajat = this.updtCriterio;
            agregarResolucionOBJ.TipoResolucionID_TipoResolucionMajat = this.tablaResolucion.params.tiporesolucionid;
            agregarResolucionOBJ.ObservacionesResolucion = this.tablaResolucion.params.observacionesResolucion;
            agregarResolucionOBJ.ObservacionesExtracto = this.tablaResolucion.params.observacionesExtracto;
            agregarResolucionOBJ.TipoDeProcedencia = this.tablaResolucion.params.tipoDeProcedenciaId;
            agregarResolucionOBJ.Magistrado = this.tablaResolucion.params.magistrado;
                        
            peticion.append('RESOLUCION',this.tablaResolucion.params.archivoDeResolucion);
            peticion.append('EXTRACTO',this.tablaResolucion.params.archivoDeExtracto);
            peticion.append('TipoPlantilla',JSON.stringify(agregarResolucionOBJ));
            peticion.append('EsPrueba',false);

            console.log("Parametros De Edicion: ",peticion);
            
            return peticion;
        },
        evtAgregarArchivoExtracto: function(evento){
            try {
                if(evento.target.files.length > 0) {
                    this.valoresdefinidos.vurlDocumentoE = null;
                    this.tablaResolucion.params.archivoDeExtracto = evento.target.files[0];
                    this.updateDocumentoExtracto.key += 1;
                }
                else {
                    this.tablaResolucion.params.archivoDeExtracto = null;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        evtAgregarArchivoResolucion: function(evento){
            try {
                if(evento.target.files.length > 0) {
                    this.valoresdefinidos.vurlDocumentoR=null;
                    this.tablaResolucion.params.archivoDeResolucion = evento.target.files[0];
                    this.updateDocumentoResolucion.key += 1;
                }
                else {
                    this.tablaResolucion.params.archivoDeResolucion = null;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        evtCambioTipoResolucion: function(evento) {
            this.tablaResolucion.params.tiporesolucionid = parseInt(evento.target.value);
            console.log("tipoderesolucion",this.tablaResolucion.params.tiporesolucionid);
            if(this.tablaResolucion.params.tiporesolucionid != 9 && this.tablaResolucion.params.tiporesolucionid != 10){
                this.vshowdata = false;
            }else{
                this.vshowdata = true;
            }
            
        },
        evtCambioTipoDeProcedencia: function(evento) {
            this.tablaResolucion.params.tipoDeProcedenciaId = parseInt(evento.target.value);
            console.log("tipoDeProcedenciaId",this.tablaResolucion.params.tipoDeProcedenciaId);
        },
        evtCambioMagistrado: function(evento) {
            this.tablaResolucion.params.magistrado = parseInt(evento.target.value);
            console.log("magistrado",this.tablaResolucion.params.magistrado);
        },
        /**
         * Funcion encargada de llamar a servicio REST para obtener las cedul
         * @param {Object} peticion [valor correspondiente al objeto POST del servicio REST]
         * @param {Boolean} conMensajeDeRespuesta [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
         obtenerCTipoResolucion: async function() { 
            let procesoSinError = false;
            let peticion = {};
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = "SICPE/Catalogo/GetTipodeResolucion";/**api.SICPE.catalogos.catalogos.Cat_TipoResolucion;"SICPE/Catalogo/GetTipodeResolucion"*/
                const URL_API_SERVICIO = SERVIDOR + METODO_API_OBTENER;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false,false);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, TipoResolucion, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    await Promise.resolve(this.inicializarTabla({ elementos: [] }));
                } 
                else {
                    this.tablaResolucion.filtros.tipoDeResolucion.lista = TipoResolucion;
                    procesoSinError = true;
                }
                    comun.SeEstaCargandoInformacion(false);
                
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        },
        /**
         * Funcion encargada de llamar a servicio REST para obtener las cedul
         * @param {Object} peticion [valor correspondiente al objeto POST del servicio REST]
         * @param {Boolean} conMensajeDeRespuesta [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
         obtenerCTipoDeProcedencia: async function() { 
            let procesoSinError = false;
            let peticion = {};
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = "SICPE/Registro/GetTipoDeProcedencia";/**api.SICPE.catalogos.catalogos.Cat_TipoResolucion;"SICPE/Catalogo/GetTipodeResolucion"*/
                const URL_API_SERVICIO = SERVIDOR + METODO_API_OBTENER;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false,false);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, TipoDeProcedencia, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    await Promise.resolve(this.inicializarTabla({ elementos: [] }));
                } 
                else {
                    this.tablaResolucion.filtros.tipoDeProcedencia.listtipodeprocedencia = TipoDeProcedencia.map(pDB => {
                      let procedenciaObj = { ...pDB };
                      procedenciaObj.valor = pDB.Nombre
                      procedenciaObj.llave = pDB.TipoDeProcedenciaId
                      return procedenciaObj;
                    });
                    procesoSinError = true;
                }
                    comun.SeEstaCargandoInformacion(false);
                
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        },
        /**
         * Funcion encargada de llamar a servicio REST para obtener las cedul
         * @param {Object} peticion [valor correspondiente al objeto POST del servicio REST]
         * @param {Boolean} conMensajeDeRespuesta [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
         obtenerCMagistrados: async function() { 
            let procesoSinError = false;
            let peticion = {};
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = "SICPE/Registro/GetMagistrados";/**api.SICPE.catalogos.catalogos.Cat_TipoResolucion;"SICPE/Catalogo/GetTipodeResolucion"*/
                const URL_API_SERVICIO = SERVIDOR + METODO_API_OBTENER;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false,false);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Magistrados, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    await Promise.resolve(this.inicializarTabla({ elementos: [] }));
                } 
                else {
                    this.tablaResolucion.filtros.magistrados.listmagistrados = Magistrados.map(mDB => {
                      let magistradoObj = { ...mDB };
                      magistradoObj.valor = mDB.NombreCompleto
                      magistradoObj.llave = mDB.UsuarioId
                      return magistradoObj;
                    });;
                    procesoSinError = true;
                }
                    comun.SeEstaCargandoInformacion(false);
                
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        },
        /**
         * Funcion encargada de llamar a servicio REST para obtener las cedul
         * @param {Object} peticion [valor correspondiente al objeto POST del servicio REST]
         * @param {Boolean} conMensajeDeRespuesta [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
         BusquedaDeCriterios: async function() { 
          //this.$ref['agregarRes'].amparoDocumentopadreId = this.numExpediente;
            let procesoSinError = false;
            let peticion = {};
            peticion.DocumentoPadreId = this.updtCriterio;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = "SICPE/Consulta/GetCriteriosPenalesUpdate";//api.SICPE.sistema.registro.consultaAmparos.ObtenerAmparos;
                const URL_API_SERVICIO = SERVIDOR + METODO_API_OBTENER;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false,false);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, CriterioPenal, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    await Promise.resolve(this.inicializarTabla({ elementos: [] }));
                } 
                else {
                    
                    console.log("ESTO ES LA RESPUESTA DE CONSULTA",CriterioPenal);
                    procesoSinError = true;

                    this.valoresdefinidos.vurlDocumentoR = CriterioPenal[0].RutaResolucion;
                    this.valoresdefinidos.vurlDocumentoE = CriterioPenal[0].RutaExtracto;
                    this.tablaResolucion.params.observacionesExtracto = CriterioPenal[0].ObservacionE;
                    this.tablaResolucion.params.observacionesResolucion = CriterioPenal[0].ObservacionR;

                    this.valoresdefinidos.vMagistrado = parseInt(CriterioPenal[0].Magistrado);
                    this.tablaResolucion.params.magistrado = parseInt(CriterioPenal[0].Magistrado);

                    this.valoresdefinidos.vTipodeProcedencia = parseInt(CriterioPenal[0].TipoDeProcedencia);
                    this.tablaResolucion.params.tipoDeProcedenciaId = parseInt(CriterioPenal[0].TipoDeProcedencia);

                    this.valoresdefinidos.vTipodeResolucion = parseInt(CriterioPenal[0].TipoResolucion);
                    this.tablaResolucion.params.tiporesolucionid = parseInt(CriterioPenal[0].TipoResolucion);

                    this.keys.keyTipodeProcedencia +=1;
                    this.keys.keyMagistrado += 1;
                    this.keys.keyTipodeResolicion +=1;
                    this.updateDocumentoResolucion.key += 1;
                    this.updateDocumentoExtracto.key += 1;

                    
                }
                    comun.SeEstaCargandoInformacion(false);
                
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        },
        cleanParametros: function()
        {
            this.tablaResolucion.params.tiporesolucionid= -1;
            this.tablaResolucion.params.observacionesResolucion='';
            this.tablaResolucion.params.observacionesExtracto='';
            this.tablaResolucion.params.archivoDeResolucion= null;
            this.tablaResolucion.params.archivoDeExtracto= null;
            this.tablaResolucion.params.numExpediente= '';
            this.tablaResolucion.params.consecutivoTocaOral= '';
            this.tablaResolucion.params.consecutivoAmparo= '';
            this.tablaResolucion.params.amparoDocumentopadreId= -1;
            this.tablaResolucion.params.tipoDeProcedenciaId= -1;
            this.keys.keyTipodeProcedencia +=1;
            this.keys.keyMagistrado += 1;
            this.keys.keyTipodeResolicion +=1;
            this.updateDocumentoResolucion.key += 1;
            this.updateDocumentoExtracto.key += 1;
                 
            $("#cargarExtracto").val("");
            $("#cargarResolucion").val("");
            
                    
        }
      },
      created() { 
        this.obtenerCTipoResolucion();
        this.obtenerCMagistrados();
        this.obtenerCTipoDeProcedencia();
        const PARAMETROS_VISTA = router.history.current.params;
        if((PARAMETROS_VISTA != undefined || PARAMETROS_VISTA != null) && PARAMETROS_VISTA.hasOwnProperty('folio') && PARAMETROS_VISTA.hasOwnProperty('tocaOral'))
        {
            this.usuarioEditable=true;
            this.tocaOral = PARAMETROS_VISTA.tocaOral
            this.updtCriterio = PARAMETROS_VISTA.folio; 
            this.BusquedaDeCriterios();   
        }
        this.tablaResolucion.params.UsuarioId = this.$store.state.Login_Usuario.UsuarioId;
      },
      mounted(){
      }
    }
  </script>
  
  <style scoped>
    h2 {
      font-size: 18px;
      border-bottom: 2px solid #FFF;
      padding-bottom: 8px;
      margin-bottom: 12px;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/SICPE/Administracion/ResolucionAmparo.vue